module.exports = __webpack_public_path__ + "img/floor_b1_01.3766691e.png";